import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { Paper, Container } from '@material-ui/core'
import FlexView from 'react-flexview/lib'

export const PolicyCardSkeleton = () => {
  return (
    <Container maxWidth="sm">
      <Paper className="margin-top-basic">
        <FlexView className="margin-top-basic full-width space-between">
          <Skeleton variant="text" width={270} height={40} />
          <Skeleton variant="text" width={170} height={40} />
        </FlexView>
        <FlexView column className="margin-top-basic" hAlignContent={'center'}>
          <Skeleton variant="circle" width={70} height={70} />
          <Skeleton variant="text" width={270} height={30} />
        </FlexView>
        <Skeleton className="margin-top-basic" variant="rect" width={'100%'} height={130} />
      </Paper>
    </Container>
  )
}
